import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Config } from './types';

const StyledCardWidget = styled.div``;

const CardWidget: React.FC<WidgetRenderProps<Config>> = (
  props: WidgetRenderProps<Config>
): ReactElement => {
  const {
    borderData,
    backgroundData,
    backgroundImage,
    lineColor,
    visible,
    isCustomWidget,
  } = props.widgetState.config;

  if (visible === false || isCustomWidget) {
    return <></>;
  }

  return (
    <StyledCardWidget
      data-test-id={'card-widget'}
      id={'cardWidget'}
      className={'cardWidget'}
      style={{
        backgroundImage:
          backgroundData?.style === 'Image'
            ? `url('${backgroundImage?.url}')`
            : '',
        background: `${
          backgroundData?.style === 'Color' ? backgroundData.color : 'white'
        }`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        borderWidth: `${borderData?.thickness}px`,
        borderTop: `${
          borderData?.isTopBorderVisible ?? true
            ? `${borderData?.thickness}px solid`
            : 'none'
        }`,
        borderBottom: `${
          borderData?.isBottomBorderVisible ?? true
            ? `${borderData?.thickness}px solid`
            : 'none'
        }`,
        borderLeft: `${
          borderData?.isLeftBorderVisible ?? true
            ? `${borderData?.thickness}px solid`
            : 'none'
        }`,
        borderRight: `${
          borderData?.isRightBorderVisible ?? true
            ? `${borderData?.thickness}px solid`
            : 'none'
        }`,
        borderColor: `${lineColor}`,
        borderRadius: `${borderData?.radius}px`,
        backgroundClip: 'content-box',
        height: '100%',
        width: '100%',
      }}
    ></StyledCardWidget>
  );
};
export default CardWidget;
